import React from 'react';
import pet from '../assets/pet.png';
import arrow from '../assets/arrow.png';

const PetHeader = () => {
  return (
    <div className="bg-[#551e19] text-white mt-20 pb-32">
      <div className="max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center lg:justify-between px-6 md:px-16 xl:px-20">
        {/* Left Content */}
        <div className="text-center lg:text-start mt-10 xl:mt-0">
          <h1 className="text-4xl sm:text-5xl md:text-6xl xl:text-7xl font-medium leading-tight font-oswald">
            Your Pet deserves <span className="block">the Best</span>
          </h1>
          <p className="text-base md:text-lg mt-3 text-[#d89f56] font-oswald">
            Discover the finest accessories to keep your pets happy, healthy, and stylish.
          </p>
          <div className="mt-8 md:mt-10 xl:mt-14 flex justify-center lg:justify-start space-x-4">
            <button className="bg-[#E6B17E] text-white px-5 md:px-7  py-2 md:py-2  text-sm md:text-lg rounded-3xl hover:bg-[#c98c3c] flex items-center font-oswald">
              Shop Now <img src={arrow} className="ml-2 h-4 w-4" />
            </button>
            <button className="border-2 border-white px-5 md:px-7 py-2 md:py-2 text-sm md:text-lg rounded-3xl hover:bg-[#c98c3c] font-oswald flex items-center">
              Contact Us <img src={arrow} className="ml-2 h-4 w-4" />
            </button>
          </div>
        </div>

        <div className="w-full max-w-xs md:max-w-sm xl:max-w-md mt-6 lg:mt-10">
          <img src={pet} alt="Pet" className="w-full h-auto rounded-lg" />
        </div>
      </div>
    </div>
  );
};

export default PetHeader;
